export default __webpack_public_path__ + "static/media/powerladder_banner.4e988214.png";